<template>
  <RichText
    v-model:content="article.body"
    :content-updated="true"
    :theme="THEMES.LIGHT"
    :view-only="true"
  />
</template>

<script>
import { THEMES } from '../../shared/utils/view_options'
import { EMITTERS } from '../../shared/utils/emitters'
import RichText from '../../shared/components/RichText'

export default {
  name: 'ArticleContentComponent',
  components: {
    RichText,
  },
  props: {
    article: {
      title: String,
      body: String,
    },
  },
  data() {
    return {
      THEMES,
      EMITTERS,
    }
  },
  mounted() {
    this.callLoadEvent()
  },
  methods: {
    callLoadEvent() {
      const event = new CustomEvent('ArticleContentReady', {})
      window.dispatchEvent(event)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../shared/assets/styles/global';
</style>
